// eslint-disable-next-line import/no-cycle
import { APIS, clients } from '@/core/clients';

const client = clients[APIS.SELF_SERVICE.name];
const shareApi = {
  getShareWithEmailsList(payload) {
    return client.get(`/share/shares/${payload.campaignId}?type=${payload.shareType}`)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  postShareWithEmailsList(payload) {
    return client.post(`/share/shares/${payload.campaignId}`, payload.body)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  resendShareWithEmail(payload) {
    return client.post(`/share/shares/${payload.campaignId}/resend`, payload.body)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  deleteEmailFromShareWith(payload) {
    return client.delete(`/share/shares/${payload.campaignId}?type=${payload.shareType}`, { data: payload.body })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getGroupShares(payload) {
    return client.get(`/share/shares/a/${payload.advertiserId}/groups/${encodeURIComponent(payload.group)}?type=${payload.shareType}`)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  postGroupShares(payload) {
    return client.post(`/share/shares/a/${payload.advertiserId}/groups/${encodeURIComponent(payload.group)}`, payload.body)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  resendGroupShare(payload) {
    return client.post(`/share/shares/a/${payload.advertiserId}/groups/${encodeURIComponent(payload.group)}/resend`, payload.body)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  deleteGroupShare(payload) {
    return client.delete(`/share/shares/a/${payload.advertiserId}/groups/${encodeURIComponent(payload.group)}`, { data: payload.body })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
};
export default shareApi;
